'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sessions = function (_Client) {
  (0, _inherits3.default)(Sessions, _Client);

  function Sessions(opts) {
    (0, _classCallCheck3.default)(this, Sessions);

    var options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API';

    return (0, _possibleConstructorReturn3.default)(this, (Sessions.__proto__ || Object.getPrototypeOf(Sessions)).call(this, options));
  }

  (0, _createClass3.default)(Sessions, [{
    key: 'postShopifyAndOrganizationsByOrganization',
    value: function postShopifyAndOrganizationsByOrganization(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/organizations/' + encodeURIComponent(organization), (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getShopifyBySession',
    value: function getShopifyBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session), options);
    }
  }, {
    key: 'putShopifyBySession',
    value: function putShopifyBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'deleteShopifyBySession',
    value: function deleteShopifyBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session), (0, _extends3.default)({}, options, {
        method: 'DELETE'
      }));
    }
  }, {
    key: 'putShopifyAndClearBySession',
    value: function putShopifyAndClearBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session) + '/clear', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'putShopifyAndOrganizationsBySessionAndOrganization',
    value: function putShopifyAndOrganizationsBySessionAndOrganization(session, organization) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session) + '/organizations/' + encodeURIComponent(organization), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'putShopifyAndResetBySession',
    value: function putShopifyAndResetBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/shopify/' + encodeURIComponent(session) + '/reset', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'postOrganizationsByOrganization',
    value: function postOrganizationsByOrganization(organization) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/organizations/' + encodeURIComponent(organization), (0, _extends3.default)({}, options, {
        method: 'POST'
      }));
    }
  }, {
    key: 'getBySession',
    value: function getBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session), options);
    }
  }, {
    key: 'putBySession',
    value: function putBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'deleteBySession',
    value: function deleteBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session), (0, _extends3.default)({}, options, {
        method: 'DELETE'
      }));
    }
  }, {
    key: 'putClearBySession',
    value: function putClearBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session) + '/clear', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'putOrganizationsBySessionAndOrganization',
    value: function putOrganizationsBySessionAndOrganization(session, organization) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session) + '/organizations/' + encodeURIComponent(organization), (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }, {
    key: 'putResetBySession',
    value: function putResetBySession(session) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.makeRequest(this.host + '/sessions/' + encodeURIComponent(session) + '/reset', (0, _extends3.default)({}, options, {
        method: 'PUT'
      }));
    }
  }]);
  return Sessions;
}(_client2.default);

exports.default = Sessions;